import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import GppGoodIcon from '@mui/icons-material/GppGood';
import LinkIcon from '@mui/icons-material/Link';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

import SessionBookedHealth from "../components/sessions/health/SessionBookedHealth";
import MeetingUrlHealth from "../components/sessions/health/MeetingUrlHealth";
import CohostsAddedHealth from "../components/sessions/health/CohostsAddedHealth";
import PerformerJoinedHealth from "../components/sessions/health/PerformerJoinedHealth";
import RecordingAvailableHealth from "../components/sessions/health/RecordingAvailableHealth";
import DefaultHealth from "../components/sessions/health/DefaultHealth";
import PerformerCheckinHealth from '../components/sessions/health/PerformerCheckinHealth';
import ZoomLicenseHealth from '../components/sessions/health/ZoomLicenseHealth';

const iconStyle = {color: "black", fontSize: '1rem'};

export const buildHealthIndicatorIcon = (key) => {
    const defaultIcon = <QuestionMarkIcon style={iconStyle}/>;
    const sessionHealthIndicators = {
        "session-booked": <CheckCircleIcon style={iconStyle}/>,
        "check-zoom-license": <GppGoodIcon style={iconStyle}/>,
        "meeting-url-creation": <LinkIcon style={iconStyle}/>,
        "cohosts-added": <PeopleIcon style={iconStyle}/>,
        "performer-checked-in": <PersonIcon style={iconStyle}/>,
        "performer-joined-session": <AccountBoxIcon style={iconStyle}/>,
        "recordings-available": <PlayCircleIcon style={iconStyle}/>
    };
    
    return sessionHealthIndicators[key] || defaultIcon;
}

export const buildSessionHealthIndicator = (key, state, session = 'PENDING', options) => {
    const sessionHealthIndicators = {
        "session-booked": {component: SessionBookedHealth, enabled: options => options.enableSessionBookedHealthIndicator},
        "check-zoom-license": {component: ZoomLicenseHealth, enabled: options => options.enableZoomLicenseHealthIndicator},
        "meeting-url-creation": {component: MeetingUrlHealth, enabled: options => options.enableZoomLinkHealthIndicator},
        "cohosts-added": {component: CohostsAddedHealth, enabled: options => options.enableCohostsAddedHealthIndicator},
        "performer-checked-in": {component: PerformerCheckinHealth, enabled: options => options.enablePerformerCheckInHealthIndicator},
        "performer-joined-session": {component: PerformerJoinedHealth, enabled: options => options.enablePerformerJoinedHealthIndicator},
        "recordings-available": {component: RecordingAvailableHealth, enabled: options => options.enableRecordingsAvailableHealthIndicator}
    };

    let Component;

    if (!sessionHealthIndicators[key]) {
        //This handles new/unknown healthIndicator
        Component = <DefaultHealth session={session} state={state} />;
    } else if (!sessionHealthIndicators[key].enabled(options)) {
        //This handles disabled healthIndicator
        Component = null;
    } else {
        //Normal flow
        const CurrentIndicator = sessionHealthIndicators[key].component;
        Component = <CurrentIndicator session={session} state={state} />;
    }
    return Component
};

export const buildSessionHealthColor = {
    PENDING: 'white',
    SUCCESS: '#05b050',
    ERROR: '#ea605d'
};
